import React from 'react';

import { useI18n } from 'i18n/I18nContext';
import trackEvent from 'utils/trackEvent';

export interface CtaWithHintProps {
  href: string;
  buttonLabel: string;
  hint?: string;
  className?: string;
  /** White-tinted hint for photo / green heroes */
  onDark?: boolean;
  /** Analytics event name (defaults to cta_click) */
  trackName?: string;
  trackProps?: Record<string, string | number | boolean | undefined>;
}

const CTA_CLASS =
  'gb-btn bg-green shadow text-white text-lg font-bold px-25 py-20 rounded-lg inline-block no-underline';

const CtaWithHint = ({
  href,
  buttonLabel,
  hint,
  className = '',
  onDark = false,
  trackName = 'cta_click',
  trackProps,
}: CtaWithHintProps) => {
  const { localizePath, locale } = useI18n();
  const localizedHref = localizePath(href);
  const hintClass = onDark ? 'gb-cta-hint gb-cta-hint--on-dark' : 'gb-cta-hint';

  return (
    <div className={`gb-cta-stack ${className}`.trim()}>
      <a
        href={localizedHref}
        className={CTA_CLASS}
        onClick={() => trackEvent(trackName, { href, locale, ...(trackProps || {}) })}
      >
        {buttonLabel}
      </a>
      {hint ? <p className={`${hintClass} text-sm mt-15 leading-normal m-0`}>{hint}</p> : null}
    </div>
  );
};

export default CtaWithHint;



// WEBPACK FOOTER //
// ./src/components/CtaWithHint.tsx